export default function getEmail(state) {
  let email = undefined;
  if (state.loginForm && state.loginForm.email) {
    email = state.loginForm.email.trim();
  }
  return email;
}